import type { StarsButtonProps } from '@ps/web-shared-components';
import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useHistory } from 'react-router-dom';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import type { MultiPurposeNotification } from '@swf/core/types/Notification';

import type { CardAction } from '../../config/NotificationTypes';
import type { NotificationType } from '../../enums';
import { ActionType } from '../../enums';
import { geti18NValueConfig } from '../../utils';

import styles from './Buttons.scss';

export enum GroupVariant {
  Responsive = 'responsive',
  Stacked = 'stacked'
}

interface Props {
  actionList?: CardAction[];
  attributes?: MultiPurposeNotification['attributes'];
  notificationId?: number;
  notificationType?: NotificationType;
  primaryVariant?: StarsButtonProps['variant'];
  secondaryVariant?: StarsButtonProps['variant'];
  groupVariant?: GroupVariant;
  onClickPrimaryAction?(): void;
  onClickSecondaryAction?(): void;
}

const Buttons: React.FC<Props> = ({
  actionList = [],
  notificationType,
  attributes,
  notificationId,
  onClickPrimaryAction,
  onClickSecondaryAction,
  primaryVariant = 'primary',
  secondaryVariant = 'secondary',
  groupVariant = GroupVariant.Responsive
}) => {
  const history = useHistory();
  const buttonElements = actionList.map((actionCfg, idx) => {
    const buttonStyle =
      actionCfg.actionType === ActionType.Primary ? primaryVariant : secondaryVariant;
    const {
      actionLabel: {
        tag: { id = idx }
      }
    } = actionCfg;
    return (
      <StarsButton
        key={id}
        href={actionCfg.href}
        onClick={() => {
          actionCfg.actionType === ActionType.Primary && onClickPrimaryAction?.();
          actionCfg.actionType === ActionType.Secondary && onClickSecondaryAction?.();
          actionCfg.actionFunction?.({ attributes, notificationId, notificationType, history });
        }}
        block
        variant={buttonStyle}
        translation={actionCfg.actionLabel.tag}
        values={attributes ? geti18NValueConfig(actionCfg.actionLabel.values, attributes) : {}}
      />
    );
  });
  return (
    <ButtonGroup
      className={`${styles.actionButtons} ${styles[groupVariant as keyof typeof styles]}`}
    >
      {buttonElements}
    </ButtonGroup>
  );
};
export default Buttons;
